import { http } from '@/api/http';
import type { AuthUser, OAuthStartResponse } from './types';

/**
 * Wrapper API auth — appelle le backend Slim. Le verifier PKCE est généré et stocké
 * côté serveur (cf. ARCHITECTURE.md §9.2 — verifier ne quitte jamais le serveur).
 */
export const authApi = {
  startLichessOAuth: () => http.post<OAuthStartResponse>('/api/v1/auth/lichess/start'),
  fetchMe: () => http.get<AuthUser>('/api/v1/auth/me'),
  logout: () => http.post<{ ok: true }>('/api/v1/auth/logout'),
};
